import { TSignedInUser } from "./authTypes";
import { authApiV1 } from "../../axiosWrapper";
import { trackEvent, trackExceptionWithContext } from "../../services/application-insights/appInsights";
import { AppInsightsActions, AppInsightsComponents, AppInsightsErrorTypes } from "../../services/application-insights/appInsightsConstants";

export const getSignedInUserInfo = async (): Promise<TSignedInUser> => {
    const endpoint = `/token/userinfo`;
    const apiCallId = `auth-api-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    try {
        trackEvent(AppInsightsActions.USER_INFO_FETCH_ATTEMPT, {
            component: AppInsightsComponents.AUTH_API,
            action: 'get-signed-in-user-info-attempt',
            endpoint,
            apiCallId
        });

        const data = await authApiV1.get(endpoint, { withCredentials: true });
        const userInfo = data.data as TSignedInUser;

        trackEvent(AppInsightsActions.USER_INFO_FETCH_SUCCESS, {
            component: AppInsightsComponents.AUTH_API,
            action: 'get-signed-in-user-info-success',
            userId: userInfo.id.toString(),
            clientId: userInfo.clientId.toString(),
            subscriptionCount: userInfo.subscriptions.length,
            userRoles: userInfo.roles.join(','),
            isMsi: userInfo.isMsi,
            apiCallId
        });

        return Promise.resolve(userInfo);
    } catch (err: any) {
        trackExceptionWithContext(err, {
            component: AppInsightsComponents.AUTH_API,
            action: 'get-signed-in-user-info-error',
            additionalData: {
                errorType: AppInsightsErrorTypes.USER_AUTHENTICATION_ERROR,
                endpoint,
                statusCode: err.response?.status,
                errorMessage: err.message,
                responseData: err.response?.data,
                apiCallId
            }
        });
        return Promise.reject(err);
    }
};

// export const signOutUser = async (): Promise<void> => {
//     const endpoint = `/token/logout`;
//     try {
//         await authApiV1.post(endpoint, { withCredentials: true });
//         return Promise.resolve();
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };